export const SVVTOKENS_KEY = 'SVVTokens';
export const LAST_LOGIN_KEY = 'lastLogin';
export const AUTH_PROVIDER_KEY = 'oauth_provider';

export interface DecodedIdToken {
    iss: string;
    email: string;
    name: string;
    uid: string;
    svvroles: string[];
    exp: number;
}

export const parseJwt = (idTokenRaw: string): DecodedIdToken => {
    const base64 = idTokenRaw.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        atob(base64)
            .split('')
            .map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

    return JSON.parse(jsonPayload);
};

export const storageHasToken = (): boolean => {
    const lastLoginValue = sessionStorage.getItem(LAST_LOGIN_KEY);
    if (lastLoginValue !== null && sessionStorage.getItem(SVVTOKENS_KEY)) {
        const lastLogin = new Date(lastLoginValue);
        const now = new Date();
        const diff = Math.abs(lastLogin.getTime() - now.getTime()) / 3600000;
        if (diff > 7) {
            sessionStorage.removeItem(SVVTOKENS_KEY);
            return false;
        }
        return true;
    }
    return false;
};

export const VALID_SVV_ROLES = [
    'nva=0_sensitive_role1',
    'nva=0_sensitive_role2',
    'nva=0_sensitive_role3',
] as const;

export const hasValidSvvRoles = (svvroles: string[] | undefined): boolean => {
    if (!svvroles || svvroles.length === 0) {
        return false;
    }
    return svvroles.some(role =>
        VALID_SVV_ROLES.includes(role as (typeof VALID_SVV_ROLES)[number])
    );
};
